import { ChangeEvent, useState, forwardRef } from 'react';
import { InputBaseComponentProps } from '@mui/material';
import { InputMask } from '../InputWithMask';

export const SSNMask = forwardRef(
  ({ onChange, value, ...other }: { onChange: () => void } & InputBaseComponentProps, _ref) => {
    const [focused, setFocused] = useState(false);
    const valueForMask = value || '';
    const charactersAfterFive = valueForMask?.split('').slice(5).join('');
    const maskedValue = valueForMask.length < 6 ? 'XXX-XX-' : `XXX-XX-${charactersAfterFive}`;
    const ssnMask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    const hiddenMask = ['X', 'X', 'X', '-', 'X', 'X', '-', /\d/, /\d/, /\d/, /\d/];

    const handleDeleteCharacters = (cursorPosition: number, ssnWithDash: string): string => {
      let newSSNValue: string = ssnWithDash || '';

      if (cursorPosition === 6 || cursorPosition === 3) {
        newSSNValue = ssnWithDash?.slice(0, cursorPosition - 1) + ssnWithDash?.slice(cursorPosition - 1, ssnWithDash?.length);
      }
      newSSNValue = ssnWithDash?.slice(0, cursorPosition) + ssnWithDash?.slice(cursorPosition, ssnWithDash?.length);

      return (newSSNValue || '').replace(/-/g, '');
    };

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      const {currentTarget: { selectionEnd }, target: { value: dashedSSNValue }} = event;
      const cursorPosition = selectionEnd ?? 0;
      if ((event.nativeEvent as InputEvent).inputType === 'deleteContentBackward') {
        if (cursorPosition === 6 || cursorPosition === 3) { 
          event.target.value = handleDeleteCharacters(cursorPosition - 1, dashedSSNValue);
        }
        event.target.value = handleDeleteCharacters(cursorPosition, dashedSSNValue);
      } else {
        event.target.value = event.target?.value?.replace(/-/g, '');
      }

      onChange(event);
    };

    return (
      <InputMask
        {...other}
        value={focused ? value : maskedValue}
        mask={focused ? ssnMask : hiddenMask}
        onChange={handleChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
    );
  },
);
